import { render, staticRenderFns } from "./MeetDetail.vue?vue&type=template&id=2beac100&scoped=true&"
import script from "./MeetDetail.vue?vue&type=script&lang=js&"
export * from "./MeetDetail.vue?vue&type=script&lang=js&"
import style0 from "./MeetDetail.vue?vue&type=style&index=0&id=2beac100&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beac100",
  null
  
)

export default component.exports